import { PayloadAction } from "@reduxjs/toolkit";
import { call, CallEffect, put, PutEffect } from "redux-saga/effects";
import { updateDocumentStrataPlan } from "../api/documentsApi";
import { updateDocumentStrataPlanFailure } from "./documentsSlice";

export function* handleUpdateDocumentStrataPlan(
  action: PayloadAction<{ documentId: string; strataPlanNumber: string }>
): Generator<CallEffect | PutEffect, void, any> {
  try {
    yield call(
      updateDocumentStrataPlan,
      action.payload.documentId,
      action.payload.strataPlanNumber
    );
  } catch (error) {
    yield put(
      updateDocumentStrataPlanFailure(
        error instanceof Error ? error.message : "Strata plan update failed"
      )
    );
  }
}
